// Compact technical-rider block. Two-column bullet layout on desktop,
// stacks on mobile. Labels are mono-styled (uppercase + tracking) so the
// "this is the spec sheet" register is unmistakable while the rest of
// the page reads warm.

import { TECH_RIDER_INTRO, TECH_RIDER_BULLETS, TECH_RIDER_FOOTNOTE } from "../data/pressTechRider";
import PanBar from "../components/PanBar";

export default function TechRider() {
  return (
    <section
      id="tech-rider"
      style={{
        background: "#08182a",
        padding: "4rem 1.25rem 4.5rem",
        borderTop: "1px solid rgba(252,179,31,0.12)",
      }}
    >
      <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: "2rem" }}>
          <PanBar width={64} height={3} margin="0 auto 1rem" />
          <h2 style={{
            margin: "0 0 0.5rem",
            fontFamily: "var(--jop-script)",
            fontSize: "clamp(1.6rem, 4vw, 2.2rem)",
            color: "var(--jop-gold)",
            fontWeight: 700,
            letterSpacing: "-0.01em",
          }}>
            Tech rider
          </h2>
          <p style={{
            margin: "0 auto",
            maxWidth: "640px",
            fontSize: "0.96rem",
            lineHeight: 1.65,
            color: "var(--jop-cream)",
            fontFamily: "var(--jop-display)",
            opacity: 0.88,
          }}>
            {TECH_RIDER_INTRO}
          </p>
        </div>

        <dl className="jop-techrider-grid">
          {TECH_RIDER_BULLETS.map(({ label, value }) => (
            <div key={label} style={{
              padding: "1rem 1.2rem",
              background: "rgba(255,255,255,0.025)",
              border: "1px solid rgba(252,179,31,0.18)",
              borderRadius: "10px",
            }}>
              <dt style={{
                fontFamily: "var(--jop-display)",
                fontSize: "0.72rem",
                fontWeight: 800,
                letterSpacing: "0.18em",
                textTransform: "uppercase",
                color: "var(--jop-gold)",
                marginBottom: "0.4rem",
              }}>
                {label}
              </dt>
              <dd style={{
                margin: 0,
                fontFamily: "var(--jop-display)",
                fontSize: "0.94rem",
                lineHeight: 1.6,
                color: "var(--jop-cream)",
                opacity: 0.94,
              }}>
                {value}
              </dd>
            </div>
          ))}
        </dl>

        <p style={{
          margin: "1.6rem 0 0",
          textAlign: "center",
          fontFamily: "var(--jop-display)",
          fontSize: "0.86rem",
          color: "rgba(255,218,173,0.6)",
          fontStyle: "italic",
        }}>
          {TECH_RIDER_FOOTNOTE}
        </p>
      </div>

      <style>{`
        .jop-techrider-grid {
          margin: 0;
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 0.85rem;
        }
        @media (max-width: 640px) {
          .jop-techrider-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </section>
  );
}
